import { Pipe, PipeTransform, SecurityContext } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { OmsMessage } from "@obg/ngx.common";

@Pipe({ name: "obgOmsMessageContentProp" })
export class OmsLocalizeTimeMessageContentPropPipe implements PipeTransform {
	constructor(private readonly sanitizer: DomSanitizer) {}

	transform<T extends keyof StringProps>(message: OmsMessage, key: T, sanitize = true): string {
		const value = (message?.content?.[key] || "") as string;

		return sanitize ? this.sanitizer.sanitize(SecurityContext.HTML, value) ?? "" : value;
	}
}

type Content = NonNullable<OmsMessage["content"]>;

type StringProps = {
	[K in keyof Content]: NonNullable<Content[K]> extends string ? NonNullable<Content[K]> : never;
};
